import { useEffect } from "react";

const BASE_TITLE = "Holzbuddy | Premium-Holzbau Meran – Zimmerei Südtirol";
const BASE_URL   = "https://holzbuddy.team";

/**
 * Lightweight per-page SEO – updates <title>, <meta description>,
 * <link canonical> and og:title / og:description dynamically.
 */
export function SEO({ title, description, canonical, ogImage }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | Holzbuddy` : BASE_TITLE;

    // Title
    document.title = fullTitle;

    // Meta description
    const setMeta = (selector, attr, value) => {
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [k, v] = attr.split("=");
        el.setAttribute(k.replace("[", "").replace("]", "").split("\"")[0], v.replace(/"/g, ""));
        document.head.appendChild(el);
      }
      if (value) el.setAttribute("content", value);
    };

    if (description) {
      setMeta('meta[name="description"]', 'name="description"', description);
      setMeta('meta[property="og:description"]', 'property="og:description"', description);
      setMeta('meta[name="twitter:description"]', 'name="twitter:description"', description);
    }

    // og:title + twitter:title
    setMeta('meta[property="og:title"]', 'property="og:title"', fullTitle);
    setMeta('meta[name="twitter:title"]', 'name="twitter:title"', fullTitle);

    // og:image
    if (ogImage) {
      setMeta('meta[property="og:image"]', 'property="og:image"', ogImage);
    }

    // Canonical
    let canEl = document.querySelector('link[rel="canonical"]');
    if (!canEl) {
      canEl = document.createElement("link");
      canEl.rel = "canonical";
      document.head.appendChild(canEl);
    }
    canEl.href = canonical ? `${BASE_URL}${canonical}` : BASE_URL + "/";

    // og:url
    setMeta('meta[property="og:url"]', 'property="og:url"', canonical ? `${BASE_URL}${canonical}` : `${BASE_URL}/`);

    return () => {
      document.title = BASE_TITLE;
    };
  }, [title, description, canonical, ogImage]);

  return null;
}
